import { toast as sonnerToast } from 'sonner';
import { ToastNotification, ToastNotificationProps } from './toastNotification';
import { Status } from '@doxyme/ui-foundation/components/status';

export type ToastProps = Pick<
  ToastNotificationProps,
  'id' | 'title' | 'subtitle' | 'icon' | 'actionLink'
>;

const createToast = (toast: ToastProps) =>
  sonnerToast.custom((id) => (
    <ToastNotification
      {...toast}
      id={id}
      onDismiss={() => sonnerToast.dismiss(id)}
    />
  ));

export const toast = Object.assign(createToast, {
  success: (toast: Omit<ToastProps, 'icon'>) =>
    createToast({
      ...toast,
      icon: <Status statusLevel='success' />,
    }),
  error: (toast: Omit<ToastProps, 'icon'>) =>
    createToast({
      ...toast,
      icon: <Status statusLevel='error' />,
    }),
  warning: (toast: Omit<ToastProps, 'icon'>) =>
    createToast({
      ...toast,
      icon: <Status statusLevel='warning' />,
    }),
  info: (toast: Omit<ToastProps, 'icon'>) =>
    createToast({
      ...toast,
      icon: <Status statusLevel='info' />,
    }),
  dismiss: (id: string | number) => {
    sonnerToast.dismiss(id);
  },
});
